<div [class.oa-modern]="newTableLayout" *ngIf="!loading; else loading">
  <div
    class="oa-chart-wrap"
    [class.pt-4]="!newTableLayout"
    *ngIf="!tableOnly"
    [attr.aria-label]="(heading | translate) + ' - ' + (newLayoutRows.length ? newLayoutRows.length : barChartLabels.length) + ' ' + ('VALUES' | translate)"
    role="img"
  >
    <canvas
      baseChart
      [datasets]="barChartData"
      [labels]="barChartLabels"
      [options]="barChartOptions"
      [legend]="barChartLegend"
      [type]="'bar'"
      (chartClick)="newTableLayout ? onChartClick($event) : null"
    >
    </canvas>
  </div>

  <div class="table-responsive" *ngIf="!newTableLayout">
    <table class="table">
      <thead>
        <tr>
          <th *ngFor="let rh of tableHeaderRowData">{{ rh | translate }}</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let rowData of tableRowData">
          <td *ngFor="let data of rowData">
            <span *ngIf="isNotNumber(data); else displayNumber">{{ data | translate }}</span>
            <ng-template #displayNumber>{{ data == 0 ? '-' : (data | number : '1.0-2') }}</ng-template>
          </td>
        </tr>
      </tbody>
    </table>
  </div>

  <div class="oa-table-responsive" *ngIf="newTableLayout">
    <table class="oa-table">
      <thead>
        <tr>
          <th>{{ headerRows[0] | translate }}</th>
          <th class="oa-table__amount">{{ 'SALES_AMOUNT' | translate }}</th>
        </tr>
      </thead>
      <tbody>
        <tr
          *ngFor="let row of newLayoutRows"
          class="oa-table__row"
          [class.oa-table__row--selected]="row.key === selectedKey"
          tabindex="0"
          role="button"
          [attr.aria-pressed]="row.key === selectedKey"
          (click)="selectRow(row.key)"
          (keydown.enter)="selectRow(row.key)"
          (keydown.space)="$event.preventDefault(); selectRow(row.key)"
        >
          <td>
            <span class="oa-table__dot" *ngIf="row.key === selectedKey" aria-hidden="true"></span>
            {{ row.label | translate }}
          </td>
          <td class="oa-table__amount">{{ row.value | number: '1.0-0' }}</td>
        </tr>
      </tbody>
    </table>
  </div>
</div>

<div class="text-center dashboard-loading-spinner" *ngIf="loading">
  <div class="spinner-border" role="status">
    <span class="sr-only">Loading...</span>
  </div>
</div>
